export default {
    peronInfoTitle: "Hoàn thiện thông tin cá nhân để nhà tuyển dụng nhanh chóng nắm bắt thông tin của bạn",
    skip: "Bỏ qua",
    pleaseEnter: "Vui lòng nhập",
    pleaseSelect: "Vui lòng chọn",
    continue: "Tiếp theo",
    name: "Họ tên",
    namePlaceholder: "Vui lòng nhập họ tên",
    gender: "Giới tính",
    male: "Nam",
    female: "Nữ",
    dateOfBirth: "Ngày sinh",
    startWorkingDate: "Thời gian bắt đầu làm việc",
    jobStatus: "Trạng thái tìm việc",
    personInfoCommitWarring: "Vui lòng hoàn thiện thông tin cá nhân",
    jobIntentionTitle: "Hoàn thiện thông tin mong muốn tìm việc để làm nổi bật hồ sơ và tăng cơ hội được tuyển dụng",
    jobType: "Hình thức làm việc mong muốn",
    preferredPosition: "Vị trí mong muốn",
    preferredCity: "Thành phố mong muốn",
    preferredSalary: "Mức lương mong muốn",
    jobIntentionCommitWarring: "Vui lòng hoàn thiện mong muốn việc làm",
    educationTitle: "Hoàn thiện thông tin học vấn để thu hút các nhà tuyển dụng hàng đầu",
    school: "Trường học",
    highestDegree: "Trình độ học vấn cao nhất",
    major: "Chuyên ngành",
    studyPeriod: "Thời gian học",
    timeWarring: "Ngày bắt đầu phải trước ngày kết thúc",
    educationCommitWarring: "Vui lòng hoàn thiện thông tin học vấn",
    step1: "Bước 1",
    step2: "Bước 2",
    step3: "Bước 3",
    save: "Lưu",
    saveAndContinue: "Lưu và tiếp tục",
    savedSuccessfully: "Lưu thành công",
    startTime: "Thời gian nhập học",
    endTime: "Thời gian tốt nghiệp",
    schoolName: "Tên trường",
    cityNotFound: "Không tìm thấy thành phố",
    enterStartTime: "Vui lòng nhập thời gian nhập học",
    enterEndTime: "Vui lòng nhập thời gian tốt nghiệp",
    notAllowEmoji: "Biểu tượng cảm xúc không được phép",
};
